export default "__VITE_ASSET__D2$pjNTY__"